import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Button, Message } from "semantic-ui-react";

import FormsInputsOtp from "../../inputs/otp/forms_inputs_otp";
import OtpResendControl from "./resend_control";
import { verifyLoginOtp, resendLoginOtp } from "../../../../actions";
import { getErrorMessage, getErrorCode } from "../../../../utils/api_error";
import LoginOtpSchema from "./validate";

class FormsLoginOtp extends Component {
  state = {
    error: false,
    errorMessage: "",
  };

  render() {
    const {
      pendingToken,
      otpPrefix,
      maskedEmail,
      onRestart,
      onResent,
    } = this.props;

    return (
      <Formik
        initialValues={{ otpDigits: "" }}
        onSubmit={(values, actions) => {
          this.setState({ error: false, errorMessage: "" });
          this.props.verifyLoginOtp(
            // Joined, with no dash - the dash exists only in the email.
            { pendingToken, otpCode: `${otpPrefix}${values.otpDigits}` },
            (result, error) => {
              if (error) {
                const errorCode = getErrorCode(error);
                const errorMessage = getErrorMessage(
                  error,
                  "That code was not accepted. Request a new one below."
                );
                // The challenge is gone: only a fresh password step can
                // recover, so bounce rather than leave the admin retrying a
                // dead token forever.
                if (
                  errorCode === "OTP_MAX_ATTEMPTS" ||
                  errorCode === "SESSION_INVALID" ||
                  errorCode === "CHALLENGE_EXPIRED" ||
                  errorCode === "INVALID_CREDENTIALS"
                ) {
                  onRestart(errorMessage);
                  return;
                }
                actions.setFieldValue("otpDigits", "");
                actions.setSubmitting(false);
                this.setState({ error: true, errorMessage });
                return;
              }
              // On success leave isSubmitting set. DO_LOGIN_SUCCESS is
              // dispatched a tick after this callback, and the login page
              // redirects off the resulting user state - same as the password
              // form does today.
            }
          );
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={LoginOtpSchema}
        render={({ isSubmitting }) => (
          <Form>
            <Field
              name="otpDigits"
              label=""
              component={FormsInputsOtp}
              prefix={`${otpPrefix}-`}
              secondaryLabel={
                maskedEmail
                  ? `Enter the 4 digits from the code sent to ${maskedEmail}`
                  : "Enter the 4 digits from the code sent to your email"
              }
            />
            &nbsp;
            <Button
              type="submit"
              primary
              fluid
              loading={isSubmitting}
              disabled={isSubmitting}>
              Verify and Log In
            </Button>
            <OtpResendControl
              pendingToken={pendingToken}
              resend={(token, cb) =>
                this.props.resendLoginOtp({ pendingToken: token }, cb)
              }
              onResent={onResent}
              onSessionLost={onRestart}
            />
            <Button
              type="button"
              basic
              fluid
              size="small"
              style={{
                marginTop: "1em",
                marginBottom: "1em",
                padding: 0,
                boxShadow: "none",
              }}
              onClick={() => onRestart("")}>
              Back to login
            </Button>
            {this.state.error && (
              <Message negative style={{ marginTop: "2em" }}>
                {this.state.errorMessage}
              </Message>
            )}
          </Form>
        )}
      />
    );
  }
}

export default connect(null, {
  verifyLoginOtp,
  resendLoginOtp,
})(FormsLoginOtp);
